
function PageLoading({ content = null }) {
    return (
        <div className='backdropContent pageLoading' style={{ transition: 'none' }}>

            <div className='d-flex' style={{ justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', position: 'absolute', width: '100%', zIndex: 1, rowGap: '10px' }}>
                <div className="d-flex" style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'column',  zIndex: 1, rowGap: '10px', backgroundColor : 'white', borderRadius : '20px' , padding : '20px' }}>
                    <div className="circle-loader"></div>
                    <div className="h" style={{ marginTop: '10px', fontSize: '14px', fontWeight: 500 }}> Processing your request.....Please Wait !</div>
                </div>
            </div>
            <div className='backdrop'></div>
        </div>
    )
}

export default PageLoading
